import { authRoles } from 'app/Core/Funcionalidade/Auth';
import Login from './Login';
import Logout from './Logout';
import Organizacao from './Organizacao';
import AtualizandoPage from "app/Core/Funcionalidade/Atualizando/AtualizandoPage";
import ErrorPage from "app/Core/Funcionalidade/Error/ErrorPage";
import Token from './Token';
import RegisterPage from "../Register/RegisterPage";
import ResetPasswordPage from "../ResetPassword/ResetPasswordPage";
import ConfirmacaoEmailPage from "../ResetPassword/ConfirmacaoEmailPage";

export const LoginConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.onlyGuest,
    routes: [
        {
            path: '/pub-login',
            component: Login
        },
        {
            path: '/pub-logout',
            component: Logout
        },
        {
            path: '/pub-organizacao',
            component: Organizacao
        },
        {
            path: '/token',
            component: Token
        },
        {
            path: '/error',
            component: ErrorPage
        },
        {
            path: '/atualizando',
            component: AtualizandoPage
        },
        {
            path: '/pub-register',
            component: RegisterPage
        },
        {
            path: '/pub-reset-password',
            component: ResetPasswordPage
        },
        {
            path: '/pub-confirmar-email',
            component: ConfirmacaoEmailPage
        },
    ]
};

